export const createCsvFromArray = (array, csvName, headers = []) => {
  let localArray = []

  array.forEach((object) => {
    localArray.push(Object.values(object).join(';'))
  })
  let csvContent = 'data:text/csv;charset=utf-8,'

  if (headers.length) {
    csvContent += headers.join(';') + '\r\n'
  }

  localArray.forEach((rowArray) => {
    csvContent += rowArray + '\r\n'
  })

  let encodedUri = encodeURI(csvContent.replace(/#/g, ' '))
  let link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', `${csvName}.csv`)
  // link.innerHTML = 'Click Here to download'
  document.body.appendChild(link)
  link.click()
}
